import React from "react";
import { Box } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import useTranslation from "../../../../shared/hooks/useTranslation";
import { dt } from "../../../../shared/themes/redesignTokens";

interface NoLocationBannerProps {
  onGoToSettings?: () => void;
}

const NoLocationBanner = ({ onGoToSettings }: NoLocationBannerProps) => {
  const { translate } = useTranslation(["serviceOffers"]);

  const handleClick = () => {
    if (onGoToSettings) {
      onGoToSettings();
    } else {
      window.open("/settings/company", "_blank");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        p: "12px 16px",
        borderRadius: dt.radiusSm,
        backgroundColor: "#FFF8E1",
        border: "1px solid #FFB30030",
        mb: 1.5,
      }}
    >
      <WarningAmberIcon
        sx={{ fontSize: 20, color: "#F39C12", flexShrink: 0 }}
      />
      <Box
        sx={{
          flex: 1,
          fontFamily: dt.font,
          fontSize: "13px",
          fontWeight: 500,
          color: "#7D6608",
          lineHeight: 1.5,
        }}
      >
        {translate("noLocation.message")}
      </Box>
      <Box
        component="button"
        onClick={handleClick}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          background: "none",
          border: "none",
          cursor: "pointer",
          fontFamily: dt.font,
          fontSize: "12px",
          fontWeight: 600,
          color: "#D4A017",
          whiteSpace: "nowrap",
          p: 0,
          "&:hover": { color: "#B8860B", textDecoration: "underline" },
        }}
      >
        {translate("noLocation.goToSettings")}
        <OpenInNewIcon sx={{ fontSize: 14 }} />
      </Box>
    </Box>
  );
};

export default NoLocationBanner;
